// extracted by mini-css-extract-plugin
export default {"message":"message__LwO4p"};